const ROYALTY_BUSINESS_TIME_ZONE = 'Europe/Moscow'

const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/
const ISO_PREFIX_RE = /^(\d{4}-\d{2}-\d{2})/
const EXPLICIT_OFFSET_RE = /(Z|[+-]\d{2}:?\d{2})$/i

function formatInRoyaltyBusinessZone(date: Date): string | null {
  if (Number.isNaN(date.getTime())) return null

  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: ROYALTY_BUSINESS_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date)

  const year = parts.find((part) => part.type === 'year')?.value
  const month = parts.find((part) => part.type === 'month')?.value
  const day = parts.find((part) => part.type === 'day')?.value

  return year && month && day ? `${year}-${month}-${day}` : null
}

export function toRoyaltyBusinessDateKey(value: string | Date | null | undefined): string | null {
  if (value == null) return null

  if (value instanceof Date) {
    return formatInRoyaltyBusinessZone(value)
  }

  const raw = String(value).trim()
  if (!raw) return null

  const isoPrefix = ISO_PREFIX_RE.exec(raw)?.[1] ?? null
  if (ISO_DATE_RE.test(raw)) return raw

  // PostgreSQL date / timestamp-without-time-zone values are already business-date
  // strings in API payloads. Only timestamps with an explicit UTC/offset need zone
  // conversion (for example 2026-05-03T21:00:00Z -> 2026-05-04).
  if (!EXPLICIT_OFFSET_RE.test(raw)) return isoPrefix

  return formatInRoyaltyBusinessZone(new Date(raw)) ?? isoPrefix
}

